import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const ratioBookingAddonEntity: Entity = {
  model: model,
  repository: repository,
}

export default ratioBookingAddonEntity
